(function ($) {
    $(document).ready(function () {
        // $('.parallax img').parallax({imageSrc: $(this).attr('src')});
    });
})(jQuery);